function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/discount/${view}.vue`
    );
}

const discountRoutes = [
  /* 주차 편의 서비스 */

  // 주차요금 감면 안내
  {
    path: '/discount/info',
    name: 'discountInfo',
    component: LoadView('discountInfo'),
    meta: {
      category: ['주차 편의 서비스', '주차요금 감면 안내'],
      isLnb: true,
    },
  },
];

export default discountRoutes;
